/**
 * 知识库管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>知识库管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item label="名称：">
        <el-input size="small" v-model="formInline.name" placeholder="请输入知识库名称"></el-input>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select size="small" v-model="formInline.status" placeholder="全部">
          <el-option v-for="type in payType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search()">查询</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">新建</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="id" width="60" label="编号">
      </el-table-column>
      <el-table-column  prop="name" label="名称" width="250" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="description" label="描述" width="250" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column  prop="file" label="附件" width="180" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column sortable prop="status" label="状态" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.status=='normal'">正常</div>
          <div v-if="scope.row.status=='parsing'">解析中</div>
          <div v-if="scope.row.status=='parse_failed'">解析失败</div>
          <div v-if="scope.row.status=='disabled'">禁用</div>
          <div v-if="scope.row.status=='draft'">草稿</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="updated_at" label="更新时间" width="180" show-overflow-tooltip>

      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="statusEdit(scope.$index, scope.row)" v-if="scope.row.status=='normal'">禁用</el-button>
          <el-button size="mini" type="primary" @click="statusEdit(scope.$index, scope.row)" v-else>启用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @close="closeDialog">
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-row>
          <el-col :span="16">
            <el-form-item label="知识库名称" >
              <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入" ></el-input>
            </el-form-item>
            <el-form-item label="描述" >
                <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入"
                v-model="editForm.description">
              </el-input>
            </el-form-item>
            <el-form-item label="文件">
            <el-upload ref="knowledgeUploader" class="uploadss" action="" accept=".txt,.md,.docx,.pdf,.xls,.xlsx,.csv" :before-upload="beforeUploadFile" :http-request="customUpload" multiple :show-file-list="false">
							  <el-button size="small" type="primary" class="xzfile" :disabled="!editForm.id">点击上传</el-button>
                 <div slot="tip" class="el-upload__tip">文件类型txt、md、docx、pdf、excel、csv，最多支持50个，每个不超过50M</div>
               </el-upload>
            </el-form-item>
            <el-form-item label="" style="margin-top: -30px;width: 88%;">
               <el-alert v-if="hasUploadingFiles" title="文件正在上传，完成传输后将进入处理队列" type="info" :closable="false" show-icon class="file-state-alert"></el-alert>
              <el-alert v-else-if="isRefreshingFileStatus" title="正在同步文件处理状态" type="info" :closable="false" show-icon class="file-state-alert"></el-alert>
               <el-alert v-else-if="hasProcessingFiles" title="处理中内容暂不可检索" type="warning" :closable="false" show-icon class="file-state-alert"></el-alert>
              <el-alert v-else-if="hasReadyContent" title="知识库内容已就绪" type="success" :closable="false" show-icon class="file-state-alert"></el-alert>
              <ul class="el-upload-list el-upload-list--text">
               <li v-for="(item, key) in visibleFileList" :key="item.key" class="el-upload-list__item" :tabindex="key">
                 <span class="el-upload-list__item-name file-name"><i class="el-icon-document"></i>{{ item.name }}</span>
                 <div v-if="item.local_status === 'uploading'" class="file-uploading-status">
                   <el-progress :percentage="item.progress" :stroke-width="4"></el-progress>
                   <span>上传中</span>
                 </div>
                 <div v-else class="file-parse-status" :class="'file-parse-status--' + item.parse_status">
                   <template v-if="isProcessingFile(item)">
                     <span class="file-processing-progress"><span></span></span>
                     <span>{{ getFileStatusText(item.parse_status) }}</span>
                   </template>
                   <template v-else>
                     <i :class="getFileStatusIcon(item.parse_status)"></i>
                     <span>{{ getFileStatusText(item.parse_status) }}</span>
                   </template>
                 </div>
                 <el-tooltip v-if="isRemovableFile(item)" content="删除文件" placement="top">
                   <el-button class="file-action" type="text" icon="el-icon-delete" :loading="deletingFileId === item.id" @click="handleRemove8(item)"></el-button>
                 </el-tooltip>
                 <el-tooltip v-else-if="isRetryableFile(item)" content="重新上传文件" placement="top">
                   <el-button class="file-action" type="text" icon="el-icon-refresh" @click="retryUpload"></el-button>
                 </el-tooltip>
                 <span v-if="item.parse_status === 'failed' && item.error_message" class="file-error-message">失败原因：{{ item.error_message }}</span>
                </li>
             </ul>
           </el-form-item>
            <!-- <el-form-item label="表格类型">
              <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              :limit="3"
              :on-exceed="handleExceed"
              :file-list="fileList">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">文件类型excel、csv，最多支持50个，每个不超过50M</div>
            </el-upload>
            </el-form-item> -->
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="isSaving" :disabled="!editForm.id" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  knowledgeInit,
  knowledgeList,
  knowledgeUpload,
  knowledgeCreate,
  knowledgeSave,
  knowledgeGet,
  knowledgeSavestatus,
  knowledgeDeleteFile
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false,
      editFormVisible: false,
      isSaving: false,
      isCreating: false,
      title: '预览',
      fileList: [],
      uploadingFiles: [],
      uploadQueue: [],
      pendingUploadCount: 0,
      activeUploadCount: 0,
      deletingFileId: '',
      statusPollTimer: null,
      statusPollAttempt: 0,
      isRefreshingFileStatus: false,
      fileStatusRequestId: 0,
      editSession: 0,
      payType: [
        { key: '全部', value: '' },
        { key: '正常', value: 'normal' },
        { key: '解析中', value: 'parsing' },
        { key: '解析失败', value: 'parse_failed' },
        { key: '禁用', value: 'disabled' },
        { key: '草稿', value: 'draft' },
      ],
      editForm: {
        id: '',
        name: '',
        description: '',
      },
      formInline: {
        page: 1,
        page_size: 10,
        name: '',
        status: 'normal',
      },
      listData: [],
      rules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        userRealName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        roleId: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        userMobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1(3\d|47|5((?!4)\d)|7(0|1|[6-8])|8\d)\d{8,8}$/,
            required: true,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ],
        userEmail: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            required: true,
            message: '请输入正确的邮箱',
            trigger: 'blur'
          }
        ],
        userSex: [{ required: true, message: '请选择性别', trigger: 'blur' }]
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  computed: {
    visibleFileList() {
      return this.uploadingFiles.concat(this.fileList)
    },
    hasUploadingFiles() {
      return this.uploadingFiles.length > 0 || this.uploadQueue.length > 0
    },
    hasProcessingFiles() {
      return this.fileList.some(file => this.isProcessingFile(file))
    },
    hasReadyContent() {
      return !this.hasUploadingFiles && !this.isRefreshingFileStatus && !this.hasProcessingFiles && this.fileList.some(file => file.parse_status === 'success')
    }
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeDestroy() {
    this.stopFileStatusPolling()
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    beforeUploadFile(file) {
      if (!this.editForm.id) {
        this.$message.error('知识库初始化未完成，请稍后再试')
        return false
      }
      const extension = file.name.split('.').pop().toLowerCase()
      const allowedExtensions = ['txt', 'md', 'docx', 'pdf', 'xls', 'xlsx', 'csv']
      if (allowedExtensions.indexOf(extension) === -1) {
        this.$message.error('仅支持 txt、md、docx、pdf、excel、csv 文件')
        return false
      }
      if (file.size / 1024 / 1024 >= 50) {
        this.$message.error('上传的文件大小不能超过 50MB!')
        return false
      }
      if (this.fileList.length + this.uploadingFiles.length + this.pendingUploadCount >= 50) {
        this.$message.error('当前知识库最多支持 50 个文件')
        return false
      }
      this.pendingUploadCount += 1
      return true
    },
    customUpload(request) {
      this.pendingUploadCount = Math.max(0, this.pendingUploadCount - 1)
      const knowledgeId = this.editForm.id
      const session = this.editSession
      if (!knowledgeId) {
        request.onError(new Error('知识库初始化未完成'))
        return
      }
      const item = {
        key: `upload-${session}-${request.file.uid}`,
        name: request.file.name,
        local_status: 'uploading',
        progress: 0
      }
      this.uploadingFiles.push(item)
      this.uploadQueue.push({ request, item, knowledgeId, session })
      this.processUploadQueue()
    },
    processUploadQueue() {
      while (this.activeUploadCount < 3 && this.uploadQueue.length > 0) {
        const task = this.uploadQueue.shift()
        if (!this.isCurrentEdit(task.knowledgeId, task.session)) {
          this.removeUploadingFile(task.item.key)
          task.request.onError(new Error('上传已取消'))
          continue
        }
        this.activeUploadCount += 1
        this.sendUploadTask(task)
      }
    },
    sendUploadTask(task) {
      const formData = new FormData()
      formData.append('file', task.request.file)
      knowledgeUpload(task.knowledgeId, formData, event => {
        if (!event.total || !this.isCurrentEdit(task.knowledgeId, task.session)) {
          return
        }
        const progress = Math.min(100, Math.round(event.loaded * 100 / event.total))
        task.item.progress = progress
        task.request.onProgress({ percent: progress })
      })
        .then(response => {
          if (response && response.status >= 200 && response.status < 300) {
            task.request.onSuccess(response.data)
            if (this.isCurrentEdit(task.knowledgeId, task.session)) {
              this.isRefreshingFileStatus = true
              this.loadFileStatus(task.knowledgeId, task.session)
            }
            return
          }
          task.request.onError(response)
          if (this.isCurrentEdit(task.knowledgeId, task.session)) {
            this.$message.error(this.getResponseMessage(response, '文件上传失败，请稍后再试'))
          }
        })
        .catch(error => {
          task.request.onError(error)
          if (this.isCurrentEdit(task.knowledgeId, task.session)) {
            this.$message.error(this.getResponseMessage(error, '文件上传失败，请稍后再试'))
          }
        })
        .then(() => {
          this.finishUploadTask(task)
        })
    },
    finishUploadTask(task) {
      this.removeUploadingFile(task.item.key)
      this.activeUploadCount = Math.max(0, this.activeUploadCount - 1)
      this.processUploadQueue()
    },
    removeUploadingFile(key) {
      this.uploadingFiles = this.uploadingFiles.filter(item => item.key !== key)
    },
    loadFileStatus(id, session) {
      if (!id || !this.isCurrentEdit(id, session) || this.isPageHidden()) {
        return Promise.resolve()
      }
      const requestId = ++this.fileStatusRequestId
      return knowledgeGet(id)
        .then(response => {
          if (!this.isCurrentEdit(id, session) || requestId !== this.fileStatusRequestId) {
            return
          }
          if (response && response.message === 'success' && response.data) {
            this.fileList = (response.data.files || []).map(fileInfo => ({
              key: `file-${fileInfo.id}`,
              name: fileInfo.filename,
              id: fileInfo.id,
              url: fileInfo.url,
              parse_status: fileInfo.parse_status,
              error_message: fileInfo.error_message
            }))
            this.isRefreshingFileStatus = false
            this.scheduleFileStatusPolling()
            return
          }
          this.scheduleFileStatusPolling()
        })
        .catch(() => {
          if (this.isCurrentEdit(id, session)) {
            this.scheduleFileStatusPolling()
          }
        })
    },
    scheduleFileStatusPolling() {
      this.stopFileStatusPolling(false)
      if (!this.editFormVisible || this.isPageHidden() || (!this.hasProcessingFiles && !this.isRefreshingFileStatus)) {
        if (!this.hasProcessingFiles && !this.isRefreshingFileStatus) {
          this.statusPollAttempt = 0
        }
        return
      }
      const delay = this.statusPollAttempt >= 3 ? 5000 : 2000
      const knowledgeId = this.editForm.id
      const session = this.editSession
      this.statusPollTimer = setTimeout(() => {
        this.statusPollTimer = null
        this.statusPollAttempt += 1
        this.loadFileStatus(knowledgeId, session)
      }, delay)
    },
    stopFileStatusPolling(resetAttempt = true) {
      if (this.statusPollTimer) {
        clearTimeout(this.statusPollTimer)
        this.statusPollTimer = null
      }
      if (resetAttempt) {
        this.statusPollAttempt = 0
      }
    },
    handleVisibilityChange() {
      if (this.isPageHidden()) {
        this.stopFileStatusPolling(false)
      } else if (this.hasProcessingFiles || this.isRefreshingFileStatus) {
        this.loadFileStatus(this.editForm.id, this.editSession)
      }
    },
    isPageHidden() {
      return typeof document !== 'undefined' && document.hidden
    },
    isCurrentEdit(id, session) {
      return this.editFormVisible && this.editForm.id === id && this.editSession === session
    },
    isProcessingFile(file) {
      return file.parse_status === 'queued' || file.parse_status === 'parsing'
    },
    isRemovableFile(file) {
      return file.parse_status === 'success'
    },
    isRetryableFile(file) {
      return file.parse_status === 'failed'
    },
    getFileStatusText(status) {
      const labels = {
        queued: '等待处理',
        parsing: '处理中',
        success: '已就绪',
        failed: '处理失败'
      }
      return labels[status] || '状态待确认'
    },
    getFileStatusIcon(status) {
      if (status === 'success') {
        return 'el-icon-circle-check'
      }
      if (status === 'failed') {
        return 'el-icon-circle-close'
      }
      return 'el-icon-warning'
    },
    getResponseMessage(response, fallback) {
      return response && (response.detail || response.msg || (response.data && (response.data.detail || response.data.msg))) || fallback
    },
    retryUpload() {
      const uploader = this.$refs.knowledgeUploader
      const input = uploader && uploader.$el.querySelector('input[type=file]')
      if (input) {
        input.click()
      }
    },
    handleRemove8(file) {
      if (!this.isRemovableFile(file) || this.deletingFileId) {
        return
      }
      this.$confirm('确定要删除该文件吗？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deletingFileId = file.id
          return knowledgeDeleteFile(JSON.stringify({ file_id: file.id }))
        })
        .then(response => {
          if (!(response && response.status >= 200 && response.status < 300)) {
            this.$message.error(this.getResponseMessage(response, '删除失败，请稍后再试'))
            return
          }
          this.$message.success('删除成功！')
          this.loadFileStatus(this.editForm.id, this.editSession)
          this.getdata(this.formInline)
        })
        .catch(action => {
          if (action !== 'cancel' && action !== 'close') {
            this.$message.error('删除失败，请稍后再试')
          }
        })
        .then(() => {
          this.deletingFileId = ''
        })
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释吧
       */
       knowledgeList(parameter)
        .then(res => {
          this.loading = false
          if (res.message == "success") {
            this.listData = res.data.items;
            // 分页赋值
            this.pageparm.currentPage = res.data.page_info.page
            this.pageparm.pageSize = res.data.page_info.page_size
             this.pageparm.total = res.data.page_info.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          // this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.page_size = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      console.log(this.formInline,2222)
      this.getdata(this.formInline)
    },
    // 显示编辑界面
    handleEdit(index, row) {
      this.stopFileStatusPolling()
      this.editSession += 1
      const session = this.editSession
      this.fileStatusRequestId += 1
      this.fileList = []
      this.uploadingFiles = []
      this.uploadQueue = []
      this.pendingUploadCount = 0
      this.isRefreshingFileStatus = false
      this.editFormVisible = true
      if (row) {
        this.title = '编辑'
        this.isCreating = false
        this.editForm = {
          id: row.id,
          name: row.name || '',
          description: row.description || ''
        }
        this.loadFileStatus(this.editForm.id, session)
        return
      }
      this.title = '新增'
      this.isCreating = true
      this.editForm = { id: '', name: '', description: '' }
      knowledgeInit()
        .then(response => {
          if (!this.editFormVisible || this.editSession !== session) {
            return
          }
          if (response && response.message === 'success' && response.data) {
            this.editForm.id = response.data.id
            return
          }
          this.$message.error(this.getResponseMessage(response, '知识库初始化失败，请稍后再试'))
        })
        .catch(error => {
          if (this.editFormVisible && this.editSession === session) {
            this.$message.error(this.getResponseMessage(error, '知识库初始化失败，请稍后再试'))
          }
        })
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (!valid) {
          return false
        }
        if (!this.editForm.id) {
          this.$message.error('知识库初始化未完成，请稍后再试')
          return false
        }
        this.isSaving = true
        const request = this.isCreating ? knowledgeCreate : knowledgeSave
        request(JSON.stringify(this.editForm))
          .then(response => {
            this.isSaving = false
            if (!(response && response.message === 'success')) {
              this.$message.error(this.getResponseMessage(response, '保存失败，请稍后再试'))
              return
            }
            this.isCreating = false
            this.title = '编辑'
            this.getdata(this.formInline)
            if (this.hasUploadingFiles || this.isRefreshingFileStatus || this.hasProcessingFiles) {
              this.$message.success('知识库已保存，处理中内容暂不可检索。')
              return
            }
            this.$message.success('知识库内容已就绪。')
            this.closeDialog()
          })
          .catch(error => {
            this.isSaving = false
            this.$message.error(this.getResponseMessage(error, '保存失败，请稍后再试'))
          })
      })
    },
    //启用、禁用
    statusEdit(index, row){
      const msg = row.status === 'normal' ? '确定要禁用吗？' : '确定要启用吗？';
      this.$confirm(msg, '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let datas = {kb_id:row.id}
          if(row.status == 'normal'){
            datas.status = 'disabled';
          }else{
            datas.status = 'normal';
          }
          knowledgeSavestatus(JSON.stringify(datas))
            .then(res => {
              if (res.message == "success") {
                this.$message({
                  type: 'success',
                  message: '操作成功!'
                })
                this.formInline.status = 'normal',
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.detail
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('操作失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
    },
     // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          ConfigDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('支付配置信息删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.stopFileStatusPolling()
      this.editSession += 1
      this.fileStatusRequestId += 1
      this.uploadQueue.forEach(task => task.request.onError(new Error('上传已取消')))
      this.uploadQueue = []
      this.uploadingFiles = []
      this.fileList = []
      this.pendingUploadCount = 0
      this.isRefreshingFileStatus = false
      this.isSaving = false
      this.isCreating = false
      this.editFormVisible = false
      this.editForm = { id: '', name: '', description: '' }
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.file-state-alert {
  margin: 8px 0;
}
.el-upload-list__item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-height: 30px;
  height: auto;
  padding: 5px 8px;
}
.file-name {
  flex: 1 1 180px;
  min-width: 0;
  margin-right: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.file-uploading-status,
.file-parse-status {
  display: flex;
  flex: 0 1 220px;
  align-items: center;
  gap: 8px;
  min-width: 130px;
  font-size: 12px;
}
.file-uploading-status .el-progress {
  flex: 1;
}
.file-parse-status--success {
  color: #67c23a;
}
.file-parse-status--failed {
  color: #f56c6c;
}
.file-parse-status--queued,
.file-parse-status--parsing {
  color: #606266;
}
.file-processing-progress {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 4px;
  overflow: hidden;
  border-radius: 2px;
  background: #dcdfe6;
}
.file-processing-progress > span {
  position: absolute;
  top: 0;
  left: -40%;
  width: 40%;
  height: 100%;
  background: #409eff;
  animation: file-processing 1.2s ease-in-out infinite;
}
.file-action {
  flex: 0 0 auto;
  margin-left: 8px;
}
.file-error-message {
  flex: 0 0 100%;
  margin-top: 3px;
  color: #f56c6c;
  font-size: 12px;
  line-height: 18px;
}
@keyframes file-processing {
  from {
    left: -40%;
  }
  to {
    left: 100%;
  }
}
</style>







// WEBPACK FOOTER //
// src/views/knowledge/index.vue